<template>
  <div>
    <div class="row">
      <strong class="section-title form__col col-12" data-test-id="floor-title">{{ $t('floor') }}</strong>
    </div>
    <div class="row">
      <div class="col">
        <radio-group
          data-test-id="floor-joist"
          group="floor-joist"
          :options="floorJoistOptions"
          :label="$t('floorJoist')"
          v-model="technicalFeatures.floorJoist"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RadioGroup from '@/components/atoms/RadioGroup'

export default {
  components: { RadioGroup },
  props: {
    technicalFeatures: Object
  },
  data() {
    return {
      floorJoistOptions: [
        { label: this.$t('spacing400mmOrLess'), value: 'spacing400mmOrLess' },
        { label: this.$t('spacing500mmOrMore'), value: 'spacing500mmOrMore' }
      ]
    }
  }
}
</script>

<style lang="scss">
@import '../../../../utilities/config';

.section {
  .radio-group {
    display: block !important;
    justify-content: space-between;
    align-items: center;

    .radio-group-label {
      font-size: unset;
      font-weight: unset;
    }
  }
}
</style>
